module.exports = __webpack_public_path__ + "af02fdb2445846c70d23c4794cf06505.glb";